export default __webpack_public_path__ + "img/7f480e9ee489e5452b5f4375b65aec10.png";